/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
  dashboard: {
    id: 'dashboard',
    defaultMessage: 'My Dashboard',
  },
  totalBalance: {
    id: 'totalBalance',
    defaultMessage: 'Total Balance',
  },
  totalBalanceTooltip: {
    id: 'totalBalanceTooltip',
    defaultMessage: 'These funds are available to request from your account. A minimum of 10.00 {currency} is required.',
  },
  myBalances: {
    id: 'myBalances',
    defaultMessage: 'My {currency} Balances',
  },
  upcomingFunds: {
    id: 'upcomingFunds',
    defaultMessage: 'Upcoming Funds',
  },
  upcomingFundsTooltip: {
    id: 'upcomingFundsTooltip',
    defaultMessage: 'Funds from events that are currently selling tickets or have ended within 48 hours. Funds will become available to request 48 hours after the end of your event.',
  },
  subText1: {
    id: 'subText1',
    defaultMessage: 'All funds will be added to your Universe account balance 48 hours after the end of your event.',
  },
  subText2: {
    id: 'subText2',
    defaultMessage: 'You will be notified by email once your funds are available for withdrawal.',
  },
  balances: {
    id: 'balances',
    defaultMessage: 'Balances',
  },
  balancesTooltip: {
    id: 'balancesTooltip',
    defaultMessage: 'In order to withdraw your funds, you need to have at least 10.00 available in your account.',
  },
  requestedFunds: {
    id: 'requestedFunds',
    defaultMessage: 'Requested Funds',
  },
  noEmail: {
    id: 'noEmail',
    defaultMessage: 'Didn\'t receive an email to activate your Payouts Account?',
  },
  accessPayouts: {
    id: 'accessPayouts',
    defaultMessage: 'Access Universe Payouts',
  },
  withdrawalError: {
    id: 'withdrawalError',
    defaultMessage: 'There are no withdrawals for currency {currency}',
  },
  sentTo: {
    id: 'sentTo',
    defaultMessage: 'Sent to',
  },
  amountRequested: {
    id: 'amountRequested',
    defaultMessage: 'Amount Requested',
  },
  quickLinks: {
    id: 'quickLinks',
    defaultMessage: 'Quick Links',
  },
  chargebacks: {
    id: 'chargebacks',
    defaultMessage: 'Chargebacks',
  },
  date: {
    id: 'date',
    defaultMessage: 'Date',
  },
  eventName: {
    id: 'eventName',
    defaultMessage: 'Event',
  },
  buyerName: {
    id: 'buyerName',
    defaultMessage: 'Buyer Name',
  },
  netSales: {
    id: 'netSales',
    defaultMessage: 'Net Sales',
  },
  disputed: {
    id: 'disputed',
    defaultMessage: 'Disputed',
  },
  fee: {
    id: 'fee',
    defaultMessage: 'Fee',
  },
  status: {
    id: 'status',
    defaultMessage: 'Status',
  },
  actions: {
    id: 'actions',
    defaultMessage: 'Actions',
  },
  message: {
    id: 'message',
    defaultMessage: 'Message Buyer',
  },
  view: {
    id: 'view',
    defaultMessage: 'View Order',
  },
  currencyError: {
    id: 'currencyError',
    defaultMessage: 'No Chargebacks for currency code {currency}',
  },
  whyChargeback: {
    id: 'whyChargeback',
    defaultMessage: 'Why do I have a chargeback on my account?',
  },
  learnMore: {
    id: 'learnMore',
    defaultMessage: 'Learn more.',
  },
  requestFunds: {
    id: 'requestFunds',
    defaultMessage: 'Request Your Funds',
  },
  messages: {
    id: 'messages',
    defaultMessage: 'Messages',
  },
  paymentPrefs: {
    id: 'paymentPrefs',
    defaultMessage: 'Payment Preferences',
  },
  manageEditEvent: {
    id: 'manageEditEvent',
    defaultMessage: 'Manage / Edit My Event',
  },
  universePayouts: {
    id: 'universePayouts',
    defaultMessage: 'Universe Payouts',
  },
  usersPerms: {
    id: 'usersPerms',
    defaultMessage: 'Users and Permissions',
  },
  payout: {
    id: 'payout',
    defaultMessage: 'The funds requested have been sent to your Universe Payouts account for you to transfer.',
  },
});
